export default __webpack_public_path__ + "static/media/type-qubator.4c47cc74.svg";